import { inject } from '@angular/core';
import { CanMatchFn, Route } from '@angular/router';
import { MdtGuardService } from './mdt-guard.service';

export const canMatchMdt: CanMatchFn = (route: Route) => {
  return inject(MdtGuardService).canMatch(route);
};
